/* unplugin-vue-components disabled */var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "tp-dialog"
  }, [_c('x-dialog', {
    staticClass: "tp-x-dialog",
    attrs: {
      "hideOnBlur": _vm.hideOnBlur
    },
    model: {
      value: _vm.showToast,
      callback: function ($$v) {
        _vm.showToast = $$v;
      },
      expression: "showToast"
    }
  }, [_vm.headerUrl ? _c('div', {
    staticClass: "dialog-img"
  }, [_vm.headerUrl ? _c('img', {
    staticClass: "img",
    attrs: {
      "width": "100",
      "src": _vm.headerUrl
    }
  }) : _vm._e()]) : _vm._e(), _vm.title || _vm.hasHeaderSlot ? _c('div', {
    staticClass: "tp-dialog-title"
  }, [!_vm.hasHeaderSlot ? _c('span', [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm.hasHeaderSlot ? _vm._t("header") : _vm._e()], 2) : _vm._e(), _c('div', {
    staticClass: "tp-dialog-content"
  }, [_vm._t("default")], 2), !_vm.footerHide ? _c('div', {
    staticClass: "dialog-button"
  }, [!_vm.hasFooterSlot ? [_c('p', {
    staticClass: "dialog-button-item",
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(" " + _vm._s(_vm.cancelText) + " ")]), _c('p', {
    staticClass: "dialog-button-item",
    on: {
      "click": function ($event) {
        return _vm.$emit('on-success');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.successText) + " ")])] : _vm._e(), _vm._t("footer")], 2) : _vm._e()])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };